import { Component, OnInit } from '@angular/core';
import { CURRENT_USER } from '@fapp/graphql';
import { RootMixin, WithMenubarMixin } from '@fapp/mixins';
import { Apollo } from 'apollo-angular';

import {
  MenuItem,
  SidebarColorConfig,
} from '../../partials/sidebar/sidebar.component';

@Component({
  selector: 'app-staff-layout',
  templateUrl: './staff-layout.component.html',
  styleUrls: ['./staff-layout.component.scss'],
  standalone: false,
})
export class StaffLayoutComponent
  extends WithMenubarMixin(RootMixin)
  implements OnInit
{
  sidebarCollapsed = false;
  isAdmin = false;

  // Custom color configuration using info theme
  sidebarColors: SidebarColorConfig = {
    background: 'var(--m4p-info-50)',
    submenuBackground: 'var(--m4p-info-100)',
    textColor: 'var(--m4p-secondary-700)',
    textHoverColor: 'var(--m4p-secondary-800)',
    activeTextColor: 'var(--m4p-info-700)',
    hoverBackground: 'var(--m4p-info-100)',
    activeBackground: 'var(--m4p-info-200)',
    submenuActiveBackground: 'var(--m4p-info-300)',
    borderColor: 'var(--m4p-info-200)',
    activeBorderColor: 'var(--m4p-info-500)',
    toggleColor: 'var(--m4p-secondary-600)',
    toggleHoverBackground: 'var(--m4p-info-100)',
  };

  menuItems: MenuItem[] = [
    {
      label: 'Dashboard',
      icon: 'mat::home',
      route: '/dashboard',
    },
    {
      label: 'SAP',
      icon: '@tui.database',
      route: null,
      children: [
        {
          label: 'Customers',
          icon: 'mat::person',
          route: '/customers',
        },
        {
          label: 'Printers',
          icon: '@tui.printer',
          route: '/customers/printers',
        },
      ],
    },
    {
      label: 'HP SDS',
      icon: '@tui.server',
      route: null,
      children: [
        {
          label: 'SDS Printers',
          icon: '@tui.printer',
          route: '/sds-printers',
        },
        {
          label: 'SDS Customers',
          icon: '@tui.user',
          route: '/sds-customers',
        },
      ],
    },
    {
      label: 'SDS Requests',
      icon: '@tui.package',
      route: '/sds-consumable-requests',
    },
    {
      label: 'Order Management',
      icon: '@tui.file-text',
      route: '/order-management',
    },
    {
      label: 'PPU Master',
      icon: 'mat::assignment',
      route: '/ppumaster',
      children: [
        {
          label: 'PPU Customers',
          icon: 'mat::assignment',
          route: '/ppumaster',
        },
        {
          label: 'PPU Data',
          icon: 'mat::storage',
          route: '/ppudata',
        },
        {
          label: 'New Month Generator',
          icon: 'mat::calendar_today',
          route: '/new-month-generator',
        },
        {
          label: 'PPU Invoicing',
          icon: 'mat::receipt_long',
          route: '/ppu-invoicing',
        },
      ],
    },
    {
      label: 'Users',
      icon: 'mat::groups',
      route: '/users',
      children: [
        {
          label: 'All Users',
          icon: 'mat::groups',
          route: '/users',
        },
        {
          label: 'Add User',
          icon: 'mat::add_circle',
          route: '/users/add',
        },
      ],
    },
    {
      label: 'Companies',
      icon: 'mat::company',
      route: '/companies',
      children: [
        {
          label: 'All Companies',
          icon: 'mat::categories',
          route: '/companies',
        },
        {
          label: 'Add Company',
          icon: 'mat::add_circle',
          route: '/companies/add',
        },
      ],
    },
    {
      label: 'My Profile',
      icon: 'mat::account_box',
      route: '/users/profile',
    },
  ];

  get filteredMenuItems(): MenuItem[] {
    return this.menuItems.filter(item => {
      // Hide Users and Companies menu items for non-Admin users
      if (
        !this.isAdmin &&
        (item.label === 'Users' || item.label === 'Companies')
      ) {
        return false;
      }
      return true;
    });
  }

  constructor(private apollo: Apollo) {
    super();
  }

  ngOnInit(): void {
    // Check if user is Admin to show/hide menu items
    this.apollo
      .watchQuery({
        query: CURRENT_USER,
      })
      .valueChanges.subscribe((result: any) => {
        if (result.data?.currentUser?.groups) {
          this.isAdmin = result.data.currentUser.groups.some(
            (group: any) => group.name === 'Admins'
          );
        }
      });
  }
}
